<template>
  <div class="cf-flex cf-flex--column cf-flex--gap-8">
    <h4 class="cf-title cf-title--4">
      {{ merchant.name }}
    </h4>

    <p
      v-if="isStoreLocationSelected"
      class="cf-subtitle cf-subtitle--3"
    >
      {{ locationAddress }}
    </p>
  </div>
</template>


<script>
  import { formatAddressInline } from '@/helpers/address-format';


  export default {
    name: 'LocationInformation',

    props: {
      merchant: {
        type: Object,
        required: true
      },

      selectedLocation: {
        type: Object,
        default() {
          return {};
        }
      }
    },

    computed: {
      isStoreLocationSelected() {
        return this.selectedLocation.storeId;
      },

      locationAddress() {
        const addr = this.selectedLocation.address;
        if (!addr) return '';
        return formatAddressInline(addr, addr.countryCode);
      }
    }
  };
</script>
